import axios from "axios";
import { profileType } from "../Type/Type";

const instance = axios.create({
    withCredentials: true,
    headers: {
        "API-KEY": "a433f4b4-abea-4438-8a03-3afd97c76f00",
    },
    baseURL: `https://social-network.samuraijs.com/api/1.0/`,

})

export const UserAPI = {
    getUsers(currentPage: number, pageSize: number) {
        return instance.get(`users?page=${currentPage}&count=${pageSize}`)
         .then(response => {
             return response.data;
         })
     },
}

export const followAPI = {
    follow(id: number) {
        return instance.post(`follow/${id}`)
            .then(response => {
                return response.data;
            })
    },

    unfollow(id: number) {
        return instance.delete(`follow/${id}`)
            .then(response => {
                return response.data;
            })
    }
}

export const profileAPI = {
    getProfile(userId: number) {
        return instance.get(`profile/${userId}`);
    },
    getUserStatus(userId: number) {
        return instance.get(`profile/status/${userId}`);
    },
    updateUserStatus(status: string) {
        return instance.put(`profile/status`, { status: status }).then((response) => response.data);
    },
    savePhoto(photoFile: any) {
        const formData = new FormData();
        formData.append("image", photoFile);
        return instance.put(`profile/photo`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
    },
    getSaveProfile(profile: profileType) {
        return instance.put(`profile`, profile)
    }
}

export enum ResultCodeEnum {
    Success = 0,
    Error = 1,
    CapchaIsRequired = 10,
}

export enum ResultCodeForCaptchaEnum {
    CapchaIsRequired = 10,
}

type MeResponseType = {
    data: {id: number, email: string, login: string}
    resultCode: ResultCodeEnum
    messages: Array<string>
}

type LoginMeResponsType = {
    data: {userId: number}
    resultCode: ResultCodeEnum | ResultCodeForCaptchaEnum
    messages: Array<string>
}

export const authAPI = {
    getHeader () {
        return instance.get<MeResponseType>(`auth/me`).then(res => res.data);
    },
    login (email: string, password: string, rememberMe: boolean, captcha:null | string = null) {
        return instance.post<LoginMeResponsType>('auth/login', {email, password, rememberMe, captcha}).then(res => res.data);
    },
    logout() {
        return instance.delete(`auth/login`);
    }
}

export const securityAPI = {
    getSecurityAPI() {
        return instance.get(`security/get-captcha-url`);
    }
}